import { Stack } from "@mui/material";
import { useBoundStore } from "useStore";
import StatCard from "./StatCard";
import StatDescription from "./StatDescription";
import Stat from "./Stat";

export default function AdsStats() {
  // La campaña seleccionada trae el objeto completo (incluye sus ads y métricas)
  const selectedCampaign = useBoundStore((state) => state.selectedCampaign);

  const ads = selectedCampaign?.ads ?? [];

  // Gasto = suma del costo de los anuncios de la campaña.
  const spent = ads.reduce((acc, ad) => acc + (ad?.cost?.value ?? 0), 0);
  // ROAS y ROAS objetivo a nivel campaña (targetRoas hoy llega 0 desde la caché:
  // requiere campaigns/search de MELI para poblarse — ver get_ads_campaigns.sql).
  const roas = selectedCampaign?.roas?.value ?? 0;
  const targetRoas = selectedCampaign?.targetRoas ?? 0;
  // TACOS: a nivel campaña usamos acos (= costo / ventas totales * 100).
  const tacos = selectedCampaign?.acos?.value ?? 0;
  const activeAds = ads.filter((ad) => ad?.active).length;

  return (
    <Stack
      spacing={4}
      direction="row"
      sx={{
        overflowX: "auto",
      }}
    >
      {/* Presupuesto Gastado */}
      <StatCard
        statDescription={
          <StatDescription
            iconType={"budget"}
            description={`Presupuesto Gastado`}
            width="60px"
            height="60px"
          />
        }
        stat={<Stat stat={spent} currency={"ARS"} />}
      />
      {/* ROAS */}
      <StatCard
        statDescription={
          <StatDescription
            iconType={"roas"}
            description={`ROAS`}
            width="60px"
            height="60px"
          />
        }
        stat={
          <Stat
            stat={roas}
            target={targetRoas > 0 ? targetRoas : undefined}
            currency={"target"}
          />
        }
      />
      {/* TACOS */}
      <StatCard
        statDescription={
          <StatDescription
            iconType={"tacos"}
            description={`TACOS`}
            width="60px"
            height="60px"
          />
        }
        stat={<Stat stat={tacos} currency={"percentage"} />}
      />

      {/* Anuncios Activos */}
      <StatCard
        statDescription={
          <StatDescription
            iconType={"active"}
            description={`Anuncios Activos`}
            width="60px"
            height="60px"
          />
        }
        stat={<Stat stat={activeAds} />}
      />
    </Stack>
  );
}
